import { Fragment, useState } from "react";
import {
  Button,
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { MdEdit } from "react-icons/md";

import "../../details components/nodes.css";
import TextField from "../../../../components/TextField";

export default function WhenSelection({ formikProps }) {
  const [editWhen, setEditWhen] = useState(
    formikProps.values?.executionFlow ? false : true
  );

  return (
    <Fragment>
      <div className="when-outer-div">
        <div>
          <div className="when-condition">
            <Typography variant="h4">WHEN</Typography>
          </div>

          {formikProps.values.stage >= 2 && (
            <div className="downward-icon">
              <div className="downward-arrow"></div>
            </div>
          )}
        </div>

        <div className="icon">
          <div className="arrow"></div>
        </div>

        <div className="select-when">
          <Fragment>
            <div className="select-when-div">
              <Typography variant="h5">
                Execute this workflow rule based on
              </Typography>

              {!editWhen && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => setEditWhen(!editWhen)}
                    style={{ padding: "2px" }}
                  >
                    <MdEdit />
                  </IconButton>
                </Tooltip>
              )}
            </div>

            <div className="select-when-field">
              <TextField
                label="Execution Flow"
                name="executionFlow"
                select
                disabled={!editWhen}
                formikProps={formikProps}
              >
                <MenuItem value="create_lead">Create Lead</MenuItem>
                <MenuItem value="update_lead">Edit Lead</MenuItem>
                <MenuItem value="create_update">Create & Edit Lead</MenuItem>
              </TextField>
            </div>

            {editWhen && (
              <Button
                onClick={() => {
                  setEditWhen(false);
                  formikProps.setValues((prev) => ({
                    ...prev,
                    stage: prev.stage >= 2 ? prev.stage : 2,
                  }));
                }}
                variant="contained"
                style={{ float: "right", marginTop: "30px" }}
              >
                Save Flow
              </Button>
            )}
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
}
